import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import CompanyName from '../../commonComponents/CompanyName';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import DateComponent from '../../commonComponents/DateComponent';
import { DateType } from '../../../static/types/commonTypes/dateType';
import ReducedManager from '../../commonComponents/ReducedManager';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { initialManagerState } from '../../../static/types/objectInitialState';
import ManagerWithRepresentative from './limited-company-creation/ManagerWithRepresentative';
import { managerWithRepresentativeInitalState } from '../../../static/initialState/limited-company-creation/managerWithRepresentativeInitialState';
import { ManagerWithRepresentativeType } from '../../../static/types/limited-company-creation/managerWithRepresentativeType';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import { ReducedManagerType } from '../../../static/types/commonTypes/reducedManagerType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import { useDraftManager } from '../../../hooks/useDraftManager';
import { formatObjectText } from '../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    denomination: string;
    activeIndex: number;
    societyType: string | string[];
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    updatesocieteSelected: (newTxt: string) => void;
    societeSelected: string;
}
const ChangementAdministration: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateDenomination,
    updateTxtAnnonce,
    updateActiveIndex,
    societyType
}) => {
    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        date, setDate,
        dateValidity, setDateValidity,
        dateChecked, setDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        reducedManager, setReducedManager,
        reducedManagerValidity, setReducedManagerValidity,
        reducedManagerChecked, setReducedManagerChecked,

        oldSecondAdministrator, setOldSecondAdministrator,
        oldSecondAdministratorValidity, setOldSecondAdministratorValidity,
        oldSecondAdministratorChecked, setOldSecondAdministratorChecked,
        typeOldAdministratorData, setTypeOldAdministratorData,

        managerWithRepresentative, setManagerWithRepresentative,
        managerWithRepresentativeValidity, setManagerWithRepresentativeValidity,
        managerWithRepresentativeChecked, setManagerWithRepresentativeChecked,

        secondManagerWithRepresentative, setSecondManagerWithRepresentative,
        secondManagerWithRepresentativeValidity, setSecondManagerWithRepresentativeValidity,
        secondManagerWithRepresentativeChecked, setSecondManagerWithRepresentativeChecked,
        typeSecondManagerWithRepresentativeData, setTypeSecondManagerWithRepresentativeData,

        lastTab, setLastTab

    } = useAppContext() as AppContextType

    const { pushDraftContent } = useDraftManager()

    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [submissive, setSubmissive] = useState<boolean>(false)

    const goToSupportPresse = () => { updateActiveIndex(2); }

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName');
        }
        else if (!dateValidity) {
            setActiveTab('administratorChange');
        }
        else if (!legalEntityValidity) {
            setActiveTab('theSociety');
        }
        else if (!reducedManagerValidity) {
            setActiveTab('oldAdministrator');
        }
        else if (typeOldAdministratorData === 1 && !oldSecondAdministratorValidity) {
            setActiveTab('oldAdministrator');
        }
        else if (!managerWithRepresentativeValidity) {
            setActiveTab('newAdministrator');
        }
        else if (typeSecondManagerWithRepresentativeData === 1 && !secondManagerWithRepresentativeValidity) {
            setActiveTab('newAdministrator');
        }

        let tempSecondOldValidity = typeOldAdministratorData === 1 ? oldSecondAdministratorValidity : true
        let tempSecondNewValidity = typeSecondManagerWithRepresentativeData === 1 ? secondManagerWithRepresentativeValidity : true

        return companyNameValidity && dateValidity && legalEntityValidity && reducedManagerValidity && managerWithRepresentativeValidity && tempSecondNewValidity && tempSecondOldValidity;
    };

    const switchTab = (tab: string) => {
        setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {

            const managerWithRepresentativeText = (manager: ManagerWithRepresentativeType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)} représentée par ${manager.entityDetails.civility === "Monsieur" ? "M. " : "Mme "} ${manager.entityDetails.lastName} ${manager.entityDetails.firstName}`
                }
                else return ''
            }

            const reducedManagerText = (manager: ReducedManagerType): string => {
                if (manager.person === "Personne physique") {
                    return ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}`
                }
                else if (manager.person === "Personne morale") {
                    return `${manager.entityDetails.companyName}`
                }
                else return ''
            }

            const tempText = `${companyName.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)},
L'AG du ${date.date} a pris acte de la fin du mandat d'administrateur de : ${reducedManagerText(reducedManager)} ${typeOldAdministratorData === 1 ? ` et ${reducedManagerText(oldSecondAdministrator)},` : ``}
Et a désigné administrateur : ${managerWithRepresentativeText(managerWithRepresentative)} ${typeSecondManagerWithRepresentativeData === 1 ? `, ${managerWithRepresentativeText(secondManagerWithRepresentative)},` : ``}
Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
            setSubmissive(true);
        }
    };

    const handleNext = () => {

        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("companyName"));
            }
        } else if (activeTab === "administratorChange") {
            setDateChecked(true)
            if (dateValidity) {
                switchTab(getNextTab("administratorChange"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "oldAdministrator") {
            setReducedManagerChecked(true)
            if (typeOldAdministratorData === 1) {
                setOldSecondAdministratorChecked(true)
                if (reducedManagerValidity && oldSecondAdministratorValidity) {
                    switchTab(getNextTab("oldAdministrator"));
                }
            }
            else if (reducedManagerValidity) {
                switchTab(getNextTab("oldAdministrator"));
            }
        } else if (activeTab === "newAdministrator") {
            setManagerWithRepresentativeChecked(true)
            if (typeSecondManagerWithRepresentativeData === 1) {
                setSecondManagerWithRepresentativeChecked(true)
                if (managerWithRepresentativeValidity && secondManagerWithRepresentativeValidity) {
                    setSubmissive(true)
                }
            }
            else if (managerWithRepresentativeValidity) {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };  
        
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['companyName', 'administratorChange', 'theSociety', 'oldAdministrator', 'newAdministrator'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "administratorChange";
        if (currentTab === "administratorChange") return "theSociety";
        if (currentTab === "theSociety") return "oldAdministrator";
        if (currentTab === "oldAdministrator") return "newAdministrator";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "newAdministrator") return "oldAdministrator";
        if (currentTab === "oldAdministrator") return "theSociety";
        if (currentTab === "theSociety") return "administratorChange";
        if (currentTab === "administratorChange") return "companyName";
        else return currentTab;
    }

    const tabs = 
    [
{key: 'companyName', label: 'Raison Sociale'},
{key: 'administratorChange', label: "Changement d'administrateur"},
{key: 'theSociety', label: 'La société'},
{key: 'oldAdministrator', label: 'Ancien Administrateur'},
{key: 'newAdministrator', label: 'Nouvel Administrateur'}
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={(updatedData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...updatedData })}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                            />
                        </div>
                    </div>

                }

                {
                    activeTab === 'administratorChange' &&
                    <DateComponent
                        id="date"
                        changeDate={(partialData: Partial<DateType>) => setDate({ ...date, ...partialData })}
                        checked={dateChecked}
                        date={date}
                        draftFieldName = 'date'
                        dateLabel="Date"
                        required={true}
                        onValidationChange={(isValid: boolean) => setDateValidity(isValid)}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <div>
                        <div className='mt-4 mb-4'>
                            <span>
                                Pour la société, veuillez préciser l'adresse du siège social
                            </span>
                        </div>
                        <div className="tab-content">
                            <LegalEntity
                                changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                                checked={legalEntityChecked}
                                legalEntity={legalEntity}
                                societyType={societyType}
                                companyName={companyName}
                                setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                                onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                                draftFieldName = 'legalEntity'
                            />
                        </div>
                    </div>
                }

                {
                    activeTab === 'oldAdministrator' &&
                    <>
                        <div>
                            <span>
                                Indiquer le nom de l'administrateur, tel qu'il est inscrit sur le Kbis.
                            </span>
                            <div>
                                <ReducedManager
                                    checked={reducedManagerChecked}
                                    manager={reducedManager}
                                    draftFieldName = 'reducedManager'
                                    setChecked={setReducedManagerChecked}
                                    setManager={setReducedManager}
                                    updateManagerValidity={(isValid: boolean) => setReducedManagerValidity(isValid)}
                                />
                            </div>
                            <div>
                                <span>
                                    Si ce changement concerne également un second administrateur, veuillez renseigner son identité
                                </span>
                                <div className="col-sm-10 d-flex align-items-center mt-1">
                                    <label htmlFor="personne" className="col-sm-2 col-form-label mb-0">
                                        Saisir données
                                    </label>
                                    <select
                                        className="form-select w-25"
                                        id="oldSecondAdministrator"
                                        onChange={(e) => {
                                            setTypeOldAdministratorData(Number(e.target.value))
                                            setOldSecondAdministrator(initialManagerState)
                                            pushDraftContent({ typeOldAdministratorData })
                                            setOldSecondAdministratorChecked(false)
                                        }}
                                        value={typeOldAdministratorData}
                                    >
                                        <option value={1}> Oui </option>
                                        <option value={0}> Non </option>
                                    </select>
                                </div>
                                {
                                    typeOldAdministratorData === 1 &&
                                    <div className='mt-2'>
                                        <ReducedManager
                                            checked={oldSecondAdministratorChecked}
                                            manager={oldSecondAdministrator}
                                            draftFieldName = 'oldSecondAdministrator'
                                            setChecked={setOldSecondAdministratorChecked}
                                            setManager={setOldSecondAdministrator}
                                            updateManagerValidity={(isValid: boolean) => setOldSecondAdministratorValidity(isValid)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                }

                {
                    activeTab === 'newAdministrator' &&
                    <>
                        <div>
                            <ManagerWithRepresentative
                                checked={managerWithRepresentativeChecked}
                                manager={managerWithRepresentative}
                                societyType={societyType}
                                setChecked={setManagerWithRepresentativeChecked}
                                setManager={setManagerWithRepresentative}
                                updateManagerValidity={(isValid: boolean) => setManagerWithRepresentativeValidity(isValid)}
                                draftFieldName = 'managerWithRepresentative'
                            />
                        </div>
                        <div>
                            <span>
                                Si ce changement concerne également l'arrivée d'un second administrateur, veuillez renseigner son identité
                            </span>
                            <div >
                                <div className="col-sm-10 d-flex align-items-center mt-1">
                                    <label htmlFor="personne" className="col-sm-2 col-form-label mb-0">
                                        Saisir données
                                    </label>
                                    <select
                                        className="form-select w-25"
                                        id="newSecondAdministrator"
                                        onChange={(e) => {
                                            setSecondManagerWithRepresentative(managerWithRepresentativeInitalState)
                                            setTypeSecondManagerWithRepresentativeData(Number(e.target.value))
                                            setSecondManagerWithRepresentativeChecked(false)
                                            pushDraftContent({ typeSecondManagerWithRepresentativeData })
                                        }}
                                        value={typeSecondManagerWithRepresentativeData}
                                    >
                                        <option value={1}> Oui </option>
                                        <option value={0}> Non </option>
                                    </select>
                                </div>

                                {
                                    typeSecondManagerWithRepresentativeData === 1 &&
                                    <div className='mt-2'>
                                        <ManagerWithRepresentative
                                            societyType={societyType}
                                            checked={secondManagerWithRepresentativeChecked}
                                            manager={secondManagerWithRepresentative}
                                            setChecked={setSecondManagerWithRepresentativeChecked}
                                            setManager={setSecondManagerWithRepresentative}
                                            updateManagerValidity={(isValid: boolean) => setSecondManagerWithRepresentativeValidity(isValid)}
                                            draftFieldName = 'secondManagerWithRepresentative'
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                }

                {
                    activeTab === "newAdministrator" &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'newAdministrator' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'newAdministrator' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'newAdministrator' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default ChangementAdministration;